export default "<figure>\n  <div>\n    <img src=\"../../../assets/images/Gears-1s-229px.svg\">\n  </div>\n</figure>"